var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-align-justify'></i> List Pengajuan Izin"
    }
  }, [_c('form', {
    attrs: {
      "action": "#/sppbmcp/listsppbmcp"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    attrs: {
      "role": "group"
    }
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "role": "group"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.q),
      expression: "q"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Pencarian",
      "type": "text"
    },
    domProps: {
      "value": (_vm.q)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.q = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.getBrows()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-sm"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("NO SPPBMCP Kolektif")]), _vm._v(" "), _c('th', [_vm._v("Tgl. SPPBMCP Kolektif")]), _vm._v(" "), _c('th', [_vm._v("Jumlah CN")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kode Billing")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Tgl. Jatuh Tempo")])])]), _vm._v(" "), _vm._l((_vm.brows.data), function(browse) {
    return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(browse.NO_SPPBMCP_KOL))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.TGL_SPPBMCP_KOL))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.JMLCN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.KD_BILLING))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.TOTAL.toLocaleString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(browse.TGL_JATUH_TEMPO))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "inline"
    }, [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.getDownload(browse.ID_SPPBMCP)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          _vm.setActiveRow(browse.ID_SPPBMCP)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-search"
    })])])])]), _vm._v(" "), (_vm.isClicked === browse.ID_SPPBMCP) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "7"
      }
    }, [_c('table', {
      attrs: {
        "width": "max"
      }
    }, [_c('tr', [_c('th', [_vm._v("NO Aju")]), _vm._v(" "), _c('th', [_vm._v("NPWP")]), _vm._v(" "), _c('th', [_vm._v("No. SPPBMCP")]), _vm._v(" "), _c('th', [_vm._v("Tgl. SPPBMCP")]), _vm._v(" "), _c('th', [_vm._v("Bea Masuk")]), _vm._v(" "), _c('th', [_vm._v("PPN")]), _vm._v(" "), _c('th', [_vm._v("PPH")]), _vm._v(" "), _c('th', [_vm._v("PPNBM")]), _vm._v(" "), _c('th', [_vm._v("BMTP")]), _vm._v(" "), _c('th', [_vm._v("TOTAL")]), _vm._v(" "), _c('th', [_vm._v("No. Barang")]), _vm._v(" "), _c('th', [_vm._v("Tgl. House BL/AWB")]), _vm._v(" "), _c('th', [_vm._v("Kode Gudang")]), _vm._v(" "), _c('th', [_vm._v("No. Kantong")]), _vm._v(" "), _c('th', [_vm._v("Kode PIBK")])]), _vm._v(" "), _vm._l((_vm.browsdtl.data), function(tes) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(tes.ID_AJU))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.ID_PEMBERITAHU))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.NO_SPPBMCP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TGL_SPPBMCP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_BM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_PPN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_PPH))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_PPNBM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_BMTP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TOTAL_TAGIHAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.NO_BARANG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.TGL_HOUSE_BLAWB))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.KD_GUDANG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.NO_KANTONG))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tes.KD_JNS_PIBK))])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "pagination"
    }, [_c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": !_vm.browsdtl.prev_page_url
      },
      on: {
        "click": function($event) {
          _vm.getBrowsDtl(_vm.id_current, _vm.browsdtl.first_page_url)
        }
      }
    }, [_vm._v("\n                      «\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": !_vm.browsdtl.prev_page_url
      },
      on: {
        "click": function($event) {
          _vm.getBrowsDtl(_vm.id_current, _vm.browsdtl.prev_page_url)
        }
      }
    }, [_vm._v("\n                      ‹\n                    ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.browsdtl.current_page + '/' + _vm.browsdtl.last_page))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": !_vm.browsdtl.next_page_url
      },
      on: {
        "click": function($event) {
          _vm.getBrowsDtl(_vm.id_current, _vm.browsdtl.next_page_url)
        }
      }
    }, [_vm._v("\n                      ›\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "disabled": !_vm.browsdtl.next_page_url
      },
      on: {
        "click": function($event) {
          _vm.getBrowsDtl(_vm.id_current, _vm.browsdtl.last_page_url)
        }
      }
    }, [_vm._v("\n                      »\n                    ")])])])]) : _vm._e()])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.first_page_url)
      }
    }
  }, [_vm._v("\n            «\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.prev_page_url)
      }
    }
  }, [_vm._v("\n            ‹\n          ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.p),
      expression: "p"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "placeholder": _vm.brows.current_page + '/' + _vm.brows.last_page,
      "type": "text",
      "size": "2"
    },
    domProps: {
      "value": (_vm.p)
    },
    on: {
      "change": function($event) {
        _vm.getBrows('bc/brows/browslist?page=' + _vm.p)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.p = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.next_page_url)
      }
    }
  }, [_vm._v("\n            ›\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.brows.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.getBrows(_vm.brows.last_page_url)
      }
    }
  }, [_vm._v("\n            »\n          ")])])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Catatan Petugas",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.ModalCatatan = false
      }
    },
    model: {
      value: (_vm.ModalCatatan),
      callback: function($$v) {
        _vm.ModalCatatan = $$v
      },
      expression: "ModalCatatan"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead'), _vm._v(" "), _c('tbody')])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bffc070","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SPPBMCP/listsppbmcp.vue
// module id = 322
// module chunks = 0